/**
 * Keeps permission-group status labels and visual emphasis consistent anywhere
 * group state affects an administrator's available actions.
 */
import type { BusinessUnitMemberGroupDto } from 'src/store/generated/leela-api-generated';

export type GroupStatus = BusinessUnitMemberGroupDto['status'];
export type GroupStatusTagType = 'success' | 'theme' | 'neutral';
export type GroupStatusLabelKey =
  | 'status_active'
  | 'status_inactive'
  | 'status_archived';

export const STATUS_TAG_TYPE: Record<GroupStatus, GroupStatusTagType> = {
  ACTIVE: 'success',
  INACTIVE: 'theme',
  ARCHIVED: 'neutral',
};

export const GroupStatusLabelKeys: Record<GroupStatus, GroupStatusLabelKey> = {
  ACTIVE: 'status_active',
  INACTIVE: 'status_inactive',
  ARCHIVED: 'status_archived',
};
